import Button from '@oneflare/flarekit/lib/components/Button';
import H2 from '@oneflare/flarekit/lib/components/H2';
import Paragraph from '@oneflare/flarekit/lib/components/Paragraph';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const QuestionStyled = styled.section`
  margin: 0 auto;
  padding: 48px 20px 0;

  ${media.lgUp`
    padding: 80px 0 0;
  `}
`;

export const QuestionWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  ${media.lgUp`
    flex-direction: row-reverse;
    padding: 0 40px;
  `}

  ${media.xlUp`
    max-width: 1440px;
    padding: 0 160px;
  `}
`;

export const QuestionContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 0 40px;

  ${media.lgUp`
    width: 50%;
    padding: 112px 0 0 8px;
  `}
`;

export const HeroImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  ${media.lgUp`
    width: 50%;
    padding: 0 8px 0 0;
  `}
`;

export const HeroImageStyled = styled.img`
  max-width: 100%;
  height: 294px;
  object-fit: contain;

  ${media.lgUp`
    height: auto;
  `}
`;

export const QuestionHeadingStyled = styled(H2)`
  font-family: ${({ theme }) => theme.font.secondaryBold};
  font-size: 28px;
  color: ${({ theme }) => theme.color.charcoal};
  margin-bottom: 8px;

  ${media.lgUp`
    margin-bottom: 16px;
  `}
`;

export const QuestionParagraphStyled = styled(Paragraph)`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.gunMetal};
  margin: 0 0 32px;
`;

export const ButtonStyled = styled(Button).attrs(() => ({
  kind: 'primary'
}))`
  width: 100%;

  ${media.smUp`
    width: 204px;
    font-size: 18px;
  `}
`;
